import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName } from "../../../../util/app";
import Select from "react-dropdown-select";

const NewShortTermAssessment = ({ onSubmit, onCancel }) => {
    const [model, setModel] = useState({ admission_tasks: [], mental: [], medical_history: [] });
    const [confirm, setConfirm] = useState(false);

    const onMentalChange = (key, event) => {
        let _model = { ...model };
        let found = false;

        for (let index = 0; index < _model.mental.length; index++) {
            if (_model.mental[index].key === key) {
                found = true;
                _model.mental[index].value = event.target.value;
            }
        }

        if (!found) {
            _model.mental.push({
                key,
                value: event.target.value,
            });
        }

        setModel(_model);
    };

    const onAdmissionTask = (key, value, applicableId) => {
        let _model = { ...model };
        let found = false;

        for (let index = 0; index < _model.admission_tasks.length; index++) {
            if (_model.admission_tasks[index].item === key) {
                found = true;
                const _applicable = document.getElementById(applicableId).checked;
                _model.admission_tasks[index].applicable = _applicable;
                _model.admission_tasks[index].comments = value;
            }
        }
        if (!found) {
            const _applicable = document.getElementById(applicableId).checked;
            _model.admission_tasks.push({
                item: key,
                applicable: _applicable,
                comments: value,
            });
        }

        setModel(_model);
    };

    // on task selection
    const onTasksSelected = (value) => {
        let _model = { ...model };
        const idx = _model.medical_history.indexOf(value);
        if (idx === -1) _model.medical_history.push(value);
        else _model.medical_history.splice(idx, 1);
        setModel(_model);
    };

    return (
        <>
            <Helmet>
                <title> New Short Term Service Assessment | {AppName}</title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    <form
                        onSubmit={(evt) => {
                            evt.preventDefault();

                            onSubmit({ model, confirm });
                        }}
                    >
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Current Presentation</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td colSpan="2">
                                            <h5 className="text-primary text-right">From direct assessment and by discussion with current carers/family</h5>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Presenting Problem. (Current Mental State and Presentation at Assessment)</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            presenting_problem: currentTarget.value,
                                                        })
                                                    }
                                                    name="presenting_problem"
                                                    id="presenting_problem"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Historical Information</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td colSpan="2">
                                            <h5 className="text-primary text-center">
                                                Give an overview of key points unless full history is not available in referring information. State sources of Historical information (referral/previous
                                                reports/self-report)
                                            </h5>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Past Psychiatric History (From first presentation to current admission)</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="past_psychiatric"
                                                    id="past_psychiatric"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            past_psychiatric: currentTarget.value,
                                                        })
                                                    }
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>full family History (Any family illness, family contact)</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            family_history: currentTarget.value,
                                                        })
                                                    }
                                                    name="full_family"
                                                    id="full_family"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Personal History (Childhood, School, Employment)</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="personal_family"
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            personal_history: currentTarget.value,
                                                        })
                                                    }
                                                    id="personal_family"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Social History (Accommodation, Social Network)</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            social_history: currentTarget.value,
                                                        })
                                                    }
                                                    name="social_family"
                                                    id="social_family"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%", verticalAlign: "top" }}>
                                            <strong>Mental State Examination</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <label htmlFor="appearance">Appearance:</label>
                                                <textarea
                                                    name="appearance"
                                                    id="appearance"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                    onChange={(event) => onMentalChange("Appearance", event)}
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="behaviour">Behaviour:</label>
                                                <textarea
                                                    name="behaviour"
                                                    onChange={(event) => onMentalChange("Behaviour", event)}
                                                    id="behaviour"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="speech">Speech:</label>
                                                <textarea
                                                    name="speech"
                                                    onChange={(event) => onMentalChange("Speech", event)}
                                                    id="speech"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="mood">Mood: (Subjective)</label>
                                                <textarea
                                                    name="mood"
                                                    onChange={(event) => onMentalChange("Mood: (Subjective)", event)}
                                                    id="mood"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="thought">Thought Disorder: </label>
                                                <textarea
                                                    name="thought"
                                                    onChange={(event) => onMentalChange("Thought Disorder", event)}
                                                    id="thought"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="thought-content">Thought Content: </label>
                                                <textarea
                                                    name="thought-content"
                                                    id="thought-content"
                                                    onChange={(event) => onMentalChange("Thought Content", event)}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="self-harm">Suicide and self-harm thoughts and intent: </label>
                                                <textarea
                                                    name="self-harm"
                                                    onChange={(event) => onMentalChange("Suicide and self-harm thoughts and intent", event)}
                                                    id="self-harm"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Hallucination">Perception/Hallucination: </label>
                                                <textarea
                                                    name="Hallucination"
                                                    id="Hallucination"
                                                    onChange={(event) => onMentalChange("Perception/Hallucination", event)}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="cognitive_functions">Cognitive Functions - Orientation: </label>
                                                <textarea
                                                    name="cognitive_functions"
                                                    id="cognitive_functions"
                                                    onChange={(event) => onMentalChange("Cognitive Functions - Orientation", event)}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="memory_immediate">Memory Immediate: </label>
                                                <textarea
                                                    name="memory_immediate"
                                                    id="memory_immediate"
                                                    onChange={(event) => onMentalChange("Memory Immediate", event)}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="memory_short">Memory - Short Term: </label>
                                                <textarea
                                                    name="memory_short"
                                                    id="memory_short"
                                                    onChange={(event) => onMentalChange("Memory - Short Term", event)}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="memory_long">Memory - Long Term: </label>
                                                <textarea
                                                    name="memory_long"
                                                    id="memory_long"
                                                    onChange={(event) => onMentalChange("Memory - Long Term", event)}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="attention">Attention and Concentration: </label>
                                                <textarea
                                                    name="attention"
                                                    onChange={(event) => onMentalChange("Attention and Concentration", event)}
                                                    id="attention"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Insight">Insight: </label>
                                                <textarea
                                                    name="Insight"
                                                    onChange={(event) => onMentalChange("Insight", event)}
                                                    id="Insight"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Physical Health</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Medical History (Please check those that apply and expend below)</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            onChange={() => onTasksSelected("Heart Conditions")}
                                                            type="checkbox"
                                                            id="customRadioInline1"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="customRadioInline1">
                                                            Heart Conditions
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            onChange={() => onTasksSelected("Epilepsy")}
                                                            type="checkbox"
                                                            id="customRadioInline2"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="customRadioInline2">
                                                            Epilepsy
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => onTasksSelected("Respiratory Problems")}
                                                            id="respiratory"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="respiratory">
                                                            Respiratory Problems
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            onChange={() => onTasksSelected("Skin Conditions")}
                                                            type="checkbox"
                                                            id="skin"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="skin">
                                                            Skin Conditions
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input onChange={() => onTasksSelected("Back Problems")} type="checkbox" id="back" name="customRadioInline1" className="custom-control-input" />
                                                        <label className="custom-control-label" htmlFor="back">
                                                            Back Problems
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            onChange={() => onTasksSelected("Stomach Problems")}
                                                            type="checkbox"
                                                            id="Stomach"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="Stomach">
                                                            Stomach Problems
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            onChange={() => onTasksSelected("Mobility Problems")}
                                                            type="checkbox"
                                                            id="Mobility"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="Mobility">
                                                            Mobility Problems
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            onChange={() => onTasksSelected("Neurological Problems")}
                                                            type="checkbox"
                                                            id="Neurological"
                                                            name="customRadioInline1"
                                                            className="custom-control-input"
                                                        />
                                                        <label className="custom-control-label" htmlFor="Neurological">
                                                            Neurological Problems
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input onChange={() => onTasksSelected("Diabetes")} type="checkbox" id="Diabetes" name="customRadioInline1" className="custom-control-input" />
                                                        <label className="custom-control-label" htmlFor="Diabetes">
                                                            Diabetes
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Physical Health Check on Admission - complete and note any specific findings</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="health_check"
                                                    id="health_check"
                                                    onChange={({ currentTarget }) => setModel({ ...model, physical_health_check: currentTarget.value })}
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Smoking Status:</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <Select
                                                    clearable={true}
                                                    options={[
                                                        { value: "Yes", label: "Yes" },
                                                        { value: "No", label: "No" },
                                                    ]}
                                                    valueField="value"
                                                    labelField="label"
                                                    separator
                                                    placeholder="-- Please Select --"
                                                    onChange={(item) =>
                                                        setModel({
                                                            ...model,
                                                            smoking_status: item[0].value,
                                                        })
                                                    }
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "30%" }}>
                                            <strong>Known Allergies:</strong>
                                        </td>
                                        <td style={{ width: "70%" }}>
                                            <div className="form-group">
                                                <div className="row justify-content-between">
                                                    <div className="col-5">
                                                        <div className="form-group">
                                                            <label htmlFor="known-all"></label>
                                                            <textarea
                                                                name="known-all"
                                                                id="known-all"
                                                                onChange={({ currentTarget }) => setModel({ ...model, known_allergies: currentTarget.value })}
                                                                className="form-control form-control-textarea"
                                                                required
                                                                rows="6"
                                                                placeholder="Enter value here.."
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-5">
                                                        <div className="form-group">
                                                            <label htmlFor="special_dietary_needs">Special Dietary Needs</label>
                                                            <textarea
                                                                name="special_dietary_needs"
                                                                id="special_dietary_needs"
                                                                className="form-control form-control-textarea"
                                                                required
                                                                onChange={({ currentTarget }) => setModel({ ...model, special_dietary: currentTarget.value })}
                                                                rows="6"
                                                                placeholder="Enter value here.."
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Any Issue with Medicines? :</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="issue_medicines"
                                                    id="issue_medicines"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                    onChange={({ currentTarget }) => setModel({ ...model, issue_with_Medicine: currentTarget.value })}
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <strong className="text-danger">Please complete the Medication card for any prescribed medicines</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Patient's View</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Patient's Perception Of Needs and goals for this hospital admission</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="patient_perception "
                                                    id="patient_perception "
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                    onChange={({ currentTarget }) => setModel({ ...model, patient_perception: currentTarget.value })}
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Admission Tasks Completed</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%" }}></td>
                                        <td style={{ width: "10%" }}>
                                            <strong>Applicable</strong>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <strong>Comments</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Physical Examination</strong>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id="customCheck1" />
                                                <label className="custom-control-label" for="customCheck1"></label>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="patient_perception"
                                                    id="patient_perception"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    onChange={({ currentTarget }) => onAdmissionTask("Physical Examination", currentTarget.value, "customCheck1")}
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Bloods:</strong>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id="Bloods" />
                                                <label className="custom-control-label" for="Bloods"></label>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="Bloods_in "
                                                    id="Bloods_in "
                                                    className="form-control form-control-textarea"
                                                    required
                                                    onChange={({ currentTarget }) => onAdmissionTask("Bloods", currentTarget.value, "Bloods")}
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>ECG:</strong>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id="ecg" />
                                                <label className="custom-control-label" for="ecg"></label>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="ecg_in"
                                                    onChange={({ currentTarget }) => onAdmissionTask("ECG", currentTarget.value, "ecg")}
                                                    id="ecg_in"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Medicines Reconciliation Letter sent to GP:</strong>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id="medicines_reconciliation" />
                                                <label className="custom-control-label" for="medicines_reconciliation"></label>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="medicines_reconciliation_in "
                                                    id="medicines_reconciliation_in "
                                                    className="form-control form-control-textarea"
                                                    required
                                                    onChange={({ currentTarget }) => onAdmissionTask("Medicines Reconciliation Letter sent to GP", currentTarget.value, "medicines_reconciliation")}
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Summarise level of Nursing Observation:</strong>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id="level_observation" />
                                                <label className="custom-control-label" for="level_observation"></label>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="level_observation_in "
                                                    id="level_observation_in "
                                                    className="form-control form-control-textarea"
                                                    required
                                                    onChange={({ currentTarget }) => onAdmissionTask("Summarise level of Nursing Observation", currentTarget.value, "level_observation")}
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Mental Capacity Assessment + Consent TO Treatment forms:</strong>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id="mental_assessment" />
                                                <label className="custom-control-label" for="mental_assessment"></label>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="form-group">
                                                <textarea
                                                    name="mental_assessment_in "
                                                    id="mental_assessment_in "
                                                    className="form-control form-control-textarea"
                                                    required
                                                    onChange={({ currentTarget }) =>
                                                        onAdmissionTask("Mental Capacity Assessment + Consent TO Treatment forms", currentTarget.value, "mental_assessment")
                                                    }
                                                    rows="6"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%", verticalAlign: "top" }}>
                                            <strong>Medication Prescribed:</strong>
                                        </td>

                                        <td style={{ width: "60%" }}>
                                            <div className="form-group">
                                                <label htmlFor="regular">Regular:</label>
                                                <textarea
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            medication_prescribed: {
                                                                ...model.medication_prescribed,
                                                                regular: currentTarget.value,
                                                            },
                                                        })
                                                    }
                                                    name="regular"
                                                    id="regular"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="prn">PRN:</label>
                                                <textarea
                                                    name="prn"
                                                    onChange={({ currentTarget }) =>
                                                        setModel({
                                                            ...model,
                                                            medication_prescribed: {
                                                                ...model.medication_prescribed,
                                                                prn: currentTarget.value,
                                                            },
                                                        })
                                                    }
                                                    id="prn"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="4"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="custom-control custom-checkbox">
                                    <input defaultChecked={confirm} type="checkbox" onChange={() => setConfirm(!confirm)} id="confirm" name="customRadioInline1" className="custom-control-input" />
                                    <label className="custom-control-label" htmlFor="confirm">
                                        Confirm on creation
                                    </label>
                                </div>
                            </div>
                            <div className="col-12 text-right">
                                <button type="button" onClick={() => onCancel()} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 margin-right-10 btn-circle">
                                    <i className="material-icons text-danger">close</i> Close
                                </button>
                                <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 btn-success btn-circle">
                                    Submit Assessment <i className="material-icons">arrow_right_alt</i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default NewShortTermAssessment;
